module.exports = __webpack_public_path__ + "static/media/step-3.eeeeb520.png";